import PropTypes from "prop-types";
import { useState } from "react";

const UserPagoForm = ({ user = [], pagos, createPago }) => {
  const [formData, setFormData] = useState({
    id_usuario: String(pagos.id_usuario || 0), // Ensure it's always a string
    cantidad: pagos.cantidad || 0,
    metodo_de_pago: pagos.metodo_de_pago || "efectivo", // Default to "efectivo"
    motivo_de_pago: pagos.motivo_de_pago || "cuota ene-mar 2025",
    receptor: user.id_usuario,
    nota: pagos.nota, // Fallback to 0 if user is undefined or empty
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createPago(formData);
      alert("Pago registrado con éxito.");
    } catch (error) {
      console.error("Error registrando el pago:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Registro de Pago</h3>

      <div className="input-group">
        <label className="label">Numero Halcon</label>
        <input
          type="text"
          name="id_usuario"
          value={formData.id_usuario}
          onChange={handleChange}
          className="input"
        />
      </div>

      <div className="input-group">
        <label className="label">Cantidad</label>
        <input
          type="number"
          name="cantidad"
          value={formData.cantidad}
          onChange={handleChange}
          className="input"
        />
      </div>

      <div className="input-group">
        <label className="label">Método de Pago</label>
        <select
          name="metodo_de_pago"
          value={formData.metodo_de_pago}
          onChange={handleChange}
          className="input"
        >
          <option value="efectivo">Efectivo</option>
          <option value="transferencia">Transferencia</option>
        </select>
      </div>
      <div className="input-group">
        <label className="label">Motivo de Pago</label>
        <select
          name="motivo_de_pago"
          value={formData.motivo_de_pago}
          onChange={handleChange}
          className="input"
        >
          <option value="cuota ene-mar 2025" selected>Cuota Ene-Mar 2025</option>
          <option value="cuota abr-jun 2025">Cuota Abr-Jun 2025</option>
          <option value="cuota jul-sep 2025">Cuota Jul-Sep 2025</option>
          <option value="cuota oct-dic 2025">Cuota Oct-Dic 2025</option>
          <option value="cuota ene-mar 2026">Cuota Ene-Mar 2026</option>
          <option value="cuota abr-jun 2026">Cuota Abr-Jun 2026</option>
          <option value="cuota jul-sep 2026">Cuota Jul-Sep 2026</option>
          <option value="cuota oct-dic 2026">Cuota Oct-Dic 2026</option>
          <option value="cuota ene-mar 2027">Cuota Ene-Mar 2027</option>
          <option value="cuota abr-jun 2027">Cuota Abr-Jun 2027</option>
          <option value="cuota jul-sep 2027">Cuota Jul-Sep 2027</option>
          <option value="cuota oct-dic 2027">Cuota Oct-Dic 2027</option>
          <option value="viaje">Viaje</option>
          <option value="maraton">Maraton</option>
          <option value="visita (no acumulable)">Visita (no acumulable)</option>
        </select>
      </div>
      <p></p>
      <div className="input-group">
        <label className="label">Nota</label>
        <textarea
          name="nota"
          value={formData.nota}
          onChange={handleChange}
          className="input"
        />
      </div>
      <p></p>
      <button type="submit" className="button">
        Registrar Pago
      </button>
    </form>
  );
};

UserPagoForm.propTypes = {
  user: PropTypes.object.isRequired, // Expecting an array of user objects
  pagos: PropTypes.array.isRequired,
  createPago: PropTypes.func.isRequired,
};

export default UserPagoForm;
